import { eventTimeline } from "@/mocks/homeContent";

const stateTone: Record<string, string> = {
  爆料: "bg-primary-500 text-background-50",
  扩散: "bg-accent-500 text-foreground-950",
  回应: "bg-secondary-600 text-background-50",
  沉淀: "bg-background-300 text-foreground-800",
};

export default function EventTimeline() {
  return (
    <section className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">CASE RECAP</p>
          <h2 className="mt-1 text-2xl font-black text-foreground-950 md:text-3xl">一起争议事件的 7 天脉络</h2>
          <p className="mt-2 text-sm text-foreground-500">从首发爆料到沉淀归档，复盘「售后风波」的完整传播链条。</p>
        </div>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-100 px-3 py-1.5 text-xs text-foreground-600">
          <i className="ri-time-line text-secondary-600" aria-hidden="true"></i>
          事件编号 #HC-0828
        </span>
      </div>

      <div className="relative mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        <span className="absolute left-0 right-0 top-[22px] hidden h-px bg-background-200 lg:block" aria-hidden="true"></span>
        {eventTimeline.map((step, idx) => (
          <div key={step.title} className="relative rounded-xl border border-background-200 bg-background-50 p-4">
            <div className="flex items-center justify-between">
              <span className="font-heading text-sm tracking-wider text-foreground-400">STEP {String(idx + 1).padStart(2, "0")}</span>
              <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium ${stateTone[step.state]}`}>
                {step.state}
              </span>
            </div>
            <p className="mt-1 font-heading text-lg text-primary-600">{step.date}</p>
            <h3 className="mt-1 text-base font-bold text-foreground-950">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-500">{step.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-5 flex flex-wrap items-center gap-3 rounded-xl bg-background-100 px-4 py-3 text-xs text-foreground-600">
        <i className="ri-information-line text-primary-600" aria-hidden="true"></i>
        时间线仅作话题梳理，节点日期与描述均来自公开讨论整理，如需纠错可在「收录与纠错」反馈。
      </div>
    </section>
  );
}